import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button", "buttonText"]
  static values = {
    expanded: { type: Boolean, default: false },
    collapsedHeight: { type: Number, default: 96 }
  }

  connect() {
    this.checkOverflow()
  }

  checkOverflow() {
    const content = this.contentTarget
    const isOverflowing = content.scrollHeight > this.collapsedHeightValue

    if (isOverflowing) {
      this.buttonTarget.classList.remove("hidden")
      if (!this.expandedValue) {
        content.style.maxHeight = `${this.collapsedHeightValue}px`
      }
    } else {
      this.buttonTarget.classList.add("hidden")
    }
  }

  toggle() {
    this.expandedValue = !this.expandedValue

    if (this.expandedValue) {
      this.contentTarget.style.maxHeight = "none"
      this.buttonTextTarget.textContent = "Show less"
    } else {
      this.contentTarget.style.maxHeight = `${this.collapsedHeightValue}px`
      this.buttonTextTarget.textContent = "Show more"
    }
  }
}
